import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeePersonalContactListService = (
  params: Types.EmployeePersonalContactListRequest
) =>
  RestAPIClient.call<Types.EmployeePersonalContactListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List.replace("{employeeId}", params.employeeId.toString())}`,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeePersonalContactCreateService = (
  params: Types.EmployeePersonalContactCreateRequest
) =>
  RestAPIClient.call<Types.EmployeePersonalContact>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create.replace(
      "{employeeId}",
      params.employeeId.toString()
    )}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeePersonalContactUpdateService = (
  params: Types.EmployeePersonalContactUpdateRequest
) =>
  RestAPIClient.call<Types.EmployeePersonalContact>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace(
      "{employeeId}",
      params.employeeId.toString()
    )}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeePersonalContactDeleteService = ({
  employeeId,
  id,
}: {
  employeeId: number;
  id: string;
}) =>
  RestAPIClient.call<Types.EmployeePersonalContact>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update.replace("{employeeId}", employeeId.toString())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeePersonalContactDetailService = ({
  employeeId,
  id,
}: {
  employeeId: number;
  id: string;
}) =>
  RestAPIClient.call<Types.EmployeePersonalContact>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail.replace("{employeeId}", employeeId.toString())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
